import { render, staticRenderFns } from "./SubmitDataset.vue?vue&type=template&id=813b64f4&scoped=true&"
import script from "./SubmitDataset.vue?vue&type=script&lang=js&"
export * from "./SubmitDataset.vue?vue&type=script&lang=js&"
import style0 from "./SubmitDataset.vue?vue&type=style&index=0&id=813b64f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813b64f4",
  null
  
)

export default component.exports